'use client';

import { useEffect, useState } from 'react';

export const useDetectColumnOverflow = (
  tableRef: React.RefObject<HTMLTableElement | null>,
  isLoading: boolean,
) => {
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false);
  const [scrollLeft, setScrollLeft] = useState<number>(0);

  useEffect(() => {
    const tableElement: HTMLTableElement | null = tableRef.current;
    const handleResize = () => {
      if (!tableRef.current) return;

      const tableWidth = tableRef.current.offsetWidth;
      const totalColumnWidth = Array.from(
        tableRef.current.querySelectorAll('th'),
      ).reduce((acc, th) => acc + th.offsetWidth, 0);

      setIsOverflowing(totalColumnWidth > tableWidth);
    };

    const handleScroll = () => {
      if (tableRef.current) {
        setScrollLeft(tableRef.current.scrollLeft);
      }
    };

    handleResize();

    globalThis.addEventListener('resize', handleResize);

    if (tableElement) {
      tableElement.addEventListener('scroll', handleScroll);
    }

    return () => {
      globalThis.removeEventListener('resize', handleResize);

      if (tableElement) {
        tableElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, [tableRef, isLoading]);

  const getIsAtTheEnd = (): boolean => {
    if (!tableRef.current) return false;

    const tableWidth = tableRef.current.offsetWidth;
    const totalColumnWidth = Array.from(
      tableRef.current.querySelectorAll('th'),
    ).reduce((acc, th) => acc + th.offsetWidth, 0);

    return scrollLeft + tableWidth >= totalColumnWidth;
  };

  const isAtEnd: boolean = getIsAtTheEnd();

  return { isOverflowing, isAtEnd };
};
